const UTM_PARAMS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term',
  'utm_content', 'utm_placement',
]

const CLICK_PARAMS = ['gclid', 'wbraid', 'gbraid', 'fbclid']

const EXTRA_PARAMS = [
  'landing_page', 'referrer', 'device_type', 'last_source',
  'first_source', 'browser_simple', 'session_id', 'fbp', 'fbc',
]

export function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function getSimpleBrowser() {
  const ua = navigator.userAgent
  if (/Edg\//.test(ua)) return 'Edge'
  if (/OPR\/|Opera/.test(ua)) return 'Opera'
  if (/Chrome\//.test(ua) && !/Chromium/.test(ua)) return 'Chrome'
  if (/Firefox\//.test(ua)) return 'Firefox'
  if (/Safari\//.test(ua) && !/Chrome/.test(ua)) return 'Safari'
  return 'Other'
}

function getDeviceType() {
  const ua = navigator.userAgent
  if (/Mobi|Android|iPhone|iPod/.test(ua)) return 'mobile'
  if (/iPad|Tablet/.test(ua)) return 'tablet'
  return 'desktop'
}

function getOrCreateSessionId() {
  const key = 'vs_session_id'
  let id = sessionStorage.getItem(key)
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36)
    sessionStorage.setItem(key, id)
  }
  return id
}

function deriveFbc(fbclid) {
  if (!fbclid) return null
  const ts = Math.floor(Date.now() / 1000)
  return `fb.1.${ts}.${fbclid}`
}

export function collectTrackingData() {
  const params = new URLSearchParams(window.location.search)

  const data = {}

  for (const key of [...UTM_PARAMS, ...CLICK_PARAMS, ...EXTRA_PARAMS]) {
    const val = params.get(key)
    if (val) data[key] = val
  }

  if (!data.landing_page) data.landing_page = window.location.href
  if (!data.referrer) data.referrer = document.referrer || null
  if (!data.device_type) data.device_type = getDeviceType()
  if (!data.browser_simple) data.browser_simple = getSimpleBrowser()
  if (!data.session_id) data.session_id = getOrCreateSessionId()

  if (!data.fbp) {
    const fbp = getCookie('_fbp')
    if (fbp) data.fbp = fbp
  }

  if (!data.fbc) {
    const fbc = getCookie('_fbc') || deriveFbc(data.fbclid)
    if (fbc) data.fbc = fbc
  }

  if (!data.first_source) {
    const stored = localStorage.getItem('vs_first_source')
    if (stored) {
      data.first_source = stored
    } else if (data.utm_source) {
      localStorage.setItem('vs_first_source', data.utm_source)
      data.first_source = data.utm_source
    }
  }

  if (!data.last_source && data.utm_source) {
    data.last_source = data.utm_source
  }

  return data
}

const STORED_TRACKING_KEY = 'vs_tracking_data'
const TRACKING_TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

export function saveTracking(data) {
  localStorage.setItem(
    STORED_TRACKING_KEY,
    JSON.stringify({ data, savedAt: Date.now() })
  )
}

export function getStoredTracking() {
  try {
    const raw = localStorage.getItem(STORED_TRACKING_KEY)
    if (!raw) return null
    const { data, savedAt } = JSON.parse(raw)
    if (Date.now() - savedAt > TRACKING_TTL_MS) {
      localStorage.removeItem(STORED_TRACKING_KEY)
      return null
    }
    return data
  } catch {
    return null
  }
}

export function clearTracking() {
  localStorage.removeItem(STORED_TRACKING_KEY)
}

export function hasAttributionParams() {
  const params = new URLSearchParams(window.location.search)
  return [...UTM_PARAMS, ...CLICK_PARAMS].some(k => params.get(k))
}
